import { render, staticRenderFns } from "./ChangeTimezone.vue?vue&type=template&id=1c3c5a07&scoped=true"
import script from "./ChangeTimezone.vue?vue&type=script&lang=js"
export * from "./ChangeTimezone.vue?vue&type=script&lang=js"
import style0 from "./ChangeTimezone.vue?vue&type=style&index=0&id=1c3c5a07&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c3c5a07",
  null
  
)

export default component.exports